:host{display:block;margin-bottom:1.5rem}
/*# sourceMappingURL=assignment-gap-choice-row.component-ALFHAHNH.css.map */
